<div class="p-4 max-w-3xl mx-auto">
  <h2 class="text-2xl font-bold mb-6">
    {{ isEditMode ? ('::EditWine' | abpLocalization) : ('::NewWine' | abpLocalization) }}
  </h2>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-2">
    <app-metro-upload-images
      [initialImageUrl]="imagePreviewUrl"
      (imageSelected)="onImageSelected($event)">
    </app-metro-upload-images>

    <!-- Name -->
    <app-metro-form-input
      label='{{"::Name" | abpLocalization}}'
      formControlName="name"
      [placeholder]='"::Name" | abpLocalization'
      size="md"
      type="text">
    </app-metro-form-input>

    <app-metro-form-select
      label="{{ '::Winery' | abpLocalization }}"
      placeholder="{{ '::SelectWinery' | abpLocalization }}"
      [options]="wineries$ | async"
      formControlName="wineryId"
      [error]="getErrorMessage('wineryId')"
      [multiple]="false">
    </app-metro-form-select>

        <!-- Varietal -->
    <app-metro-form-input
      label='{{"::Type" | abpLocalization}}'
      formControlName="varietal"
      [placeholder]='"::Varietal" | abpLocalization'
      size="md"
      type="text">
    </app-metro-form-input>

     <app-metro-form-input
      label='{{"::Harvest" | abpLocalization}}'
      formControlName="harvest"
      [placeholder]='"::Harvest" | abpLocalization'
      size="md"
      type="text">
    </app-metro-form-input>

    <!-- Description -->
    <app-metro-form-textarea
      rows="4"
      label='{{"::Description" | abpLocalization}}'
      formControlName="description"
      size="md"
      type="text">
    </app-metro-form-textarea>

        <!-- Stock -->
    <app-metro-form-input
      label='{{"::Stock" | abpLocalization}}'
      formControlName="stock"
      [placeholder]='"::InitialStock" | abpLocalization'
      size="md"
      type="number">
    </app-metro-form-input>

    <!-- Price -->
    <app-metro-form-input
      label='{{"::Price" | abpLocalization}}'
      formControlName="price"
      [placeholder]='"::EnterPrice" | abpLocalization'
      size="md"
      type="number">
    </app-metro-form-input>

    <!-- Max Order Quantity -->
    <app-metro-form-input
      label='{{"::MaxOrderQuantity" | abpLocalization}}'
      formControlName="maxOrderQuantity"
      [placeholder]='"::MaxOrderQuantity" | abpLocalization'
      size="md"
      type="number">
    </app-metro-form-input>

    <!-- Brand -->
    <app-metro-form-input
      label='{{"::Brand" | abpLocalization}}'
      formControlName="brand"
      [placeholder]='"::Brand" | abpLocalization'
      size="md"
      type="text">
    </app-metro-form-input>

    <!-- Style -->
    <app-metro-form-input
      label='{{"::Type" | abpLocalization}}'
      formControlName="type"
      [placeholder]='"::Type" | abpLocalization'
      size="md"
      type="text">
    </app-metro-form-input>

    <app-metro-form-input
      label='{{"::Code" | abpLocalization}}'
      formControlName="externalCode"
      [placeholder]='"::ExternalCode" | abpLocalization'
      size="md"
      type="text">
    </app-metro-form-input>

    <!-- Is Active -->
    <div class="flex items-center">
      <input
        id="isActive"
        type="checkbox"
        formControlName="isActive"
        class="w-4 h-4 text-metro-red bg-gray-100 border-gray-300 rounded focus:ring-metro-red">
      <label for="isActive" class="ml-2 text-sm font-medium text-gray-900">
        {{ "::IsActive" | abpLocalization }}
      </label>
    </div>

    <!-- Buttons -->
    <div class="flex justify-end pt-4 gap-2">
      <app-metro-button
        variant="secondary"
        text="{{ '::Cancel' | abpLocalization }}"
        (clicked)="onCancel()">
      </app-metro-button>
      <app-metro-button
        variant="primary"
        text="{{ isEditMode ? ('::SaveChanges' | abpLocalization) : ('::AddWine' | abpLocalization) }}"
        type="submit">
      </app-metro-button>
    </div>
  </form>
</div>
